import { z } from 'zod';

import { GetNetworkResponseSchema } from './get-network.schemas.js';

export const UpdateNetworkBodySchema = z.object({
  name: z.string().min(1),
  slug: z
    .string()
    .min(2)
    .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
});

export type UpdateNetworkBody = z.infer<typeof UpdateNetworkBodySchema>;

export const UpdateNetworkResponseSchema = GetNetworkResponseSchema;

export type UpdateNetworkResponse = z.infer<typeof UpdateNetworkResponseSchema>;
